import Home from "./home";
import Services from "./services";
import Calender from "./calender";
import Birth from "./birth";
import Reports from "./reports";
import kill from "./kills";
import milkControl from "./milk-control";
import partner from "./partner";
import creator from "./creator";
import animals from "./animals";
import closures from "./closures";
import birthConsultation from "./birth-consultation";
import profile from "./profile";
import farms from "./farms";
const modules = [
  ...Home,
  ...Services,
  ...Calender,
  ...Birth,
  ...Reports,
  ...kill,
  ...milkControl,
  ...partner,
  ...creator,
  ...animals,
  ...closures,
  ...birthConsultation,
  ...profile,
  ...farms
]
export default modules